// extracted by mini-css-extract-plugin
module.exports = {"highlightWrapper":"highlights_highlightWrapper__kLIEg","grid":"highlights_grid__SGQFG"};